import { createStore } from "redux";
import rootReducer from "./reducers";

const isDebug = process.env.NODE_ENV === 'development';

const store = isDebug ? createStore(
	rootReducer, /* preloadedState, */
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
) : createStore(
	rootReducer, /* preloadedState, */
);

export default store;